// components/welcome-home/welcome-home.component.jsx
import React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import TopBarRow from "../ui-elements/top-bar-row/top-bar-row.component";
import GoBackButton from "../ui-elements/gobackbutton";

import { BsChevronRight, BsChevronLeft } from "react-icons/bs";

import "./welcome-home.styles.scss";

const WelcomeHome = ({ numOfPrTasks }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const currentUserOrg = useSelector(
    (state) => state.user.currentUser?.organization,
  );
  const { userName, assignedTasks } = currentUser;
  const [timeOfDay, setTimeOfDay] = useState(null);

  const name = userName;
  let time = new Date();

  useEffect(() => {
    let h = time.getHours();

    if (h >= 0 && h <= 12) {
      setTimeOfDay("Good morning");
    }
    if (h > 12 && h <= 18) {
      setTimeOfDay("Good afternoon");
    }
    if (h > 18 && h <= 24) {
      setTimeOfDay("Good evening");
    }
  }, [time]);
  return (
    <div className="allHome">
      <div className="welcomeHome">
        <TopBarRow className="wH__upperRow">
          <div className="wH__everything">
            <GoBackButton />

            <h2>Personal Space</h2>

            <BsChevronRight
              size="1.2em"
              strokeWidth="0.5"
              className="si__breadcrumb_arrowright"
            />
          </div>
        </TopBarRow>
        {numOfPrTasks > 0 && (
          <div className="wH__bottomRow">
            <h4>
              {timeOfDay}, {name}!
            </h4>
            <p>
              You have{" "}
              <strong>
                {numOfPrTasks} undone {numOfPrTasks > 1 ? "tasks" : "task"}
              </strong>{" "}
              to work on.
            </p>
          </div>
        )}
        {numOfPrTasks === 0 && (
          <div className="wH__bottomRow">
            <h4>
              {timeOfDay}, {name}!
            </h4>
            <p>You don't have anything planned.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeHome;
